import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedTask } from "../linkers/types";

function removeTagFromResource(httpClient: HttpClient) {
  return (tag: Tag, resourceId: Id) =>
    httpClient
      .sendHttpRequest<LinkedTask>({
        endpoint: `/resources/${resourceId}`,
        method: HttpMethods.GET,
      })
      .then((resource) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/resources/${resourceId}`,
          method: HttpMethods.PATCH,
          data: {
            // @ts-ignore
            tags: resource.tags.filter((name) => name !== tag.name),
          },
        }),
      );
}

export { removeTagFromResource };
